export const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const staggerParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

export const maskLine = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 + i * 0.12 },
  }),
};

export const IMAGES = {
  heroStudent:
    "https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzdHVkZW50JTIwc3R1ZHlpbmclMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsfGVufDB8fHx8MTc4NTMzODAyMHww&ixlib=rb-4.1.0&q=85",
  studentSecondary:
    "https://images.unsplash.com/photo-1604177091072-b7b677a077f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzdHVkZW50JTIwc3R1ZHlpbmclMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsfGVufDB8fHx8MTc4NTMzODAyMHww&ixlib=rb-4.1.0&q=85",
  instituteMain:
    "https://images.unsplash.com/photo-1782486733735-98f26e3a29fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwbGlicmFyeSUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTMzODAyMHww&ixlib=rb-4.1.0&q=85",
  hallway:
    "https://images.unsplash.com/photo-1711873316332-acb6930211e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbGlicmFyeSUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTMzODAyMHww&ixlib=rb-4.1.0&q=85",
  terracotta:
    "https://images.unsplash.com/photo-1650835405920-ffdc88f640f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHRlcnJhY290dGElMjBvcmdhbmljJTIwc2hhcGV8ZW58MHx8fHwxNzg1MzM4MDIwfDA&ixlib=rb-4.1.0&q=85",
};

export const DEVANAGARI = ["अ", "आ", "इ", "ई", "उ", "क", "ख", "ग", "घ", "च", "ज", "ट", "ण", "त", "द", "ध", "न", "प", "ब", "भ", "म", "य", "र", "ल", "व", "श", "ष", "स", "ह"];
